<template>
  <div class="fileadministrationTop">
      <FromComm :FromArr="FromArr"></FromComm>
      <div class="CommonBtngroup">
        <CommonBtngroup :qhide="false"  @select="select" @reset="reset"></CommonBtngroup>
      </div>
  </div>
</template>

<script>
import FromArr from '../FromData/FromArr'
import FromComm from '../../components/fromComponents/Commfrom/from-comm.vue'
import CommonBtngroup from '@/components/commongroup.vue'
export default {
  name: 'FileadministrationTop',
  components: {
      FromComm,
      CommonBtngroup
  },
  props: {
    activeTab: {
      type: String,
      default: '授权书'
    }
  },
  data() {
    return {
        FromArr: []
    }
  },
  created() { },
  mounted() { 
      this.initFromArr()
  },
  activated() { },
  updated() { },
  methods: {
      initFromArr() {
         let baseFromArr = JSON.parse(JSON.stringify(FromArr))
         // 调整原有的文件名称输入框宽度
         baseFromArr[1].width = 180
         baseFromArr[1].marginLeft = 10

         if (this.activeTab === '授权书') {
           baseFromArr.push({
             modelvalue: "",
             title: "医院名称：",
             inputtype: "input",
             inputflag: true,
             fontSize: 14,
             color: "#333333",
             lableheight: 20,
             X: false,
             types: "text",
             placeholder: "请输入",
             width: 180,
             height: 32,
             disabled: false,
             marginLeft: 10,
             marginTop: 10,
             displayVal: "inline-block",
             fontWeightVal: 500,
           })
         }
         this.FromArr = baseFromArr
       },
      select(){
        this.$emit('select',this.FromArr)
      },
      reset(){
        this.FromArr.forEach((item , index) => {
          if(index == 0) {
            item.StartTime = ''
            item.EndTime = ''
          }
          item.modelvalue = ''
        })  
        this.$emit('select',this.FromArr)
      }
  },
  computed: {},
  watch: {
    activeTab: {
      handler() {
        this.initFromArr()
      }
    }
  },
}
</script>
<style scoped lang='less'>
.fileadministrationTop {
  width: 100%;
  height: 104px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #eaecef;

  .CommonBtngroup{
      // margin-top: -45px;
  }
}
</style>